import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { trackLandingVisit } from "../lib/marketingAttribution";

export default function MarketingTracker() {
  const { user } = useAuth();
  const location = useLocation();
  useEffect(() => {
    if (user === false) trackLandingVisit(window.location);
  }, [user, location.pathname, location.search]);
  return null;
}
